import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";

import { getPagePath, PAGES } from "@/config/pages";
import { isSupportedLanguage } from "@/i18n/routing";
import { useAuthStore } from "@/stores/AuthStore";

const ProtectedRoute = () => {
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();
  const { isAuthenticated } = useAuthStore();

  const loginPath = isSupportedLanguage(lang)
    ? getPagePath("login", lang)
    : PAGES.login;

  if (!isAuthenticated) {
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
